import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTaskByIdQuery } from 'api';
import { AllEntityTypes } from 'models/Task';

export const useDetails = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const { data: taskDetails = {}, refetch } = useTaskByIdQuery({ id });
  const [openEditModal, setOpenEditModal] = useState(false);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const onUpdateClick = useCallback(() => {
    setOpenEditModal(true);
  }, []);

  const onCloseUpdateClick = useCallback(() => {
    setOpenEditModal(false);
  }, []);

  const onEntityClick = useCallback(
    (type: string, id: string) => {
      let path = `${AllEntityTypes[type].path}/${id}`;
      if (AllEntityTypes[type].tab) {
        path = `${path}/${AllEntityTypes[type].tab}`;
      }
      navigate(path);
    },
    [navigate]
  );

  return {
    onUpdateClick,
    taskDetails,
    onEntityClick,
    openEditModal,
    onCloseUpdateClick,
  };
};
